const nps = {
  nps: {
    npsBreakdown: 'NPS-Aufschlüsselung',
    npsScore: 'NPS-Punktzahl',
    npsSpread: 'NPS-Spanne',
    npsDashboard: 'NPS-DASHBOARD',
    npsDetails: 'NPS-Details',
    npsTrend: 'NPS-Trend',
    verbatims: 'Kommentare',
    timePeriod: 'Zeitspanne: ',
    to: 'bis',
    pastMonths: 'Letzte %{month} Monate',
    ratingType: 'Bewertungstyp',
    systemId: 'System-ID',
    systemName: 'Systembezeichnung',
    rating: 'Bewertung',
    comments: 'Kommentare',
    all: 'Alle',
    promoter: 'Befürworter',
    promoters: 'Befürworter',
    detractor: 'Gegner',
    detractors: 'Gegner',
    passive: 'Neutral',
    noData: 'Keine Daten verfügbar',
    npsDashboardTooltip: {
      whatIs: 'Was ist der Net Promoter Score?',
      npsDefine:
        'Der Net Promoter Score ist ein Index von -100 bis 100 zur Messung der Bereitwilligkeit von Kunden, ein Unternehmen an andere weiterzuempfehlen. Er wird als Anhaltspunkt zur Einschätzung der allgemeinen Kundenzufriedenheit hinzugezogen.',
      questionIs:
        'Die Frage lautet: „Anhand einer Skala von 0 bis 10, mit welcher Wahrscheinlichkeit würden Sie unser Unternehmen an einen Freund oder Kollegen weiterempfehlen?“ Je nach ausgewähltem Wert wird der Kunde einer der folgenden Kategorien zugeordnet: „Gegner“, „Neutral“ und „Befürworter“. Aufschlüsselung der Punktzahlen: 0 - 6: Gegner, 7 - 8: Neutral, 9 - 10: Befürworter',
      determined:
        'Der Net Promoter Score (NPS) entspricht dem Prozentsatz der als Befürworter eingestuften Kunden abzüglich des prozentualen Anteils der Kunden, die Gegner sind. Daraus ergibt sich eine Punktzahl zwischen -100 und 100, die als Net Promoter Score bezeichnet wird.',
      how: 'Wie wird der NPS von Enphase für Sie ermittelt?',
      shownBelow:
        'Enphase lädt Hausbesitzer ein, in der mobilen App Enlighten Bewertungen abzugeben, wie auf den nachstehenden Seiten angezeigt. Anhand der bereitgestellten Bewertungen wird der NPS, wie oben beschrieben, ermittelt.'
    },
    timePeriodTooltip:
      'Der Standardzeitraum ist größer als 13 Monate. Wenn der NPS über einen Zeitraum von 13 Monaten hinaus nicht verfügbar ist, wird die Punktzahl ab dem ersten verfügbaren Monat einbezogen.',
    verbatimsTooltip:
      'Alle hier angezeigten Kommentare stammen von Systembetreibern, die sich bereit erklärt haben, diese mit den Installateuren zu teilen.',
    jan: "Jan'",
    feb: "Feb'",
    mar: "Mär'",
    apr: "Apr'",
    may: "Mai'",
    jun: "Jun'",
    jul: "Jul'",
    aug: "Aug'",
    sep: "Sep'",
    oct: "Okt'",
    nov: "Nov'",
    dec: "Dez'",
    ofTotal: 'von insgesamt',
    ratings: 'Bewertungen',
    numberOfReviews: 'Anzahl der Beurteilungen',
    date: 'Datum',
    between0And10: 'Bitte geben Sie einen Wert zwischen 0 und 10 ein',
    lessThan50: 'Die Anzahl der Zeichen sollte weniger als 50 betragen',
    npsBasedOnScore: `NPS von %{score} basierend auf %{count} Bewertungen`
  }
};

export default nps;
